import { render, staticRenderFns } from "./checkout-products-group.vue?vue&type=template&id=172f87b3&"
import script from "./checkout-products-group.vue?vue&type=script&lang=js&"
export * from "./checkout-products-group.vue?vue&type=script&lang=js&"
import style0 from "./checkout-products-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172f87b3')) {
      api.createRecord('172f87b3', component.options)
    } else {
      api.reload('172f87b3', component.options)
    }
    module.hot.accept("./checkout-products-group.vue?vue&type=template&id=172f87b3&", function () {
      api.rerender('172f87b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-products-group.vue"
export default component.exports